/************
 Product Swipers
 ************/

document.querySelectorAll('.productVisualSwiper').forEach(element => {
    let swiper = new Swiper(element, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: element.querySelector('.productVisualSwiperNext'),
            prevEl: element.querySelector('.productVisualSwiperPrev'),
        },
        pagination: {
            el: element.querySelector('.productVisualPag'),
            clickable: true
        }
    });
});


// setup Dropdowns
document.querySelectorAll(".productInfoDropdownTop")?.forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

/**************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#product input").forEach(function (element) {
    element.addEventListener("change", function () {

        // determine the correct swiper to show
        // if productOptionItemValuesLabelInput is 4, target the four-tins, class
        let tinsTarget = document.querySelector('.productOptionItemValuesLabelInput:checked')?.value === "4" ? "four-tins" : "two-tins";

        // if the productSellingLabelInput is sub, target the sub swiper
        let subTarget = document.querySelector('.productSellingLabelInput:checked')?.value === "sub" ? "subscription" : "one-time";

        // hide all swipers
        document.querySelectorAll('.productVisualSwiper').forEach(element => {
            element.classList.remove("active");
        });


        // find the correct swiper and show
        document.querySelector(`.productVisualSwiper.${tinsTarget}.${subTarget}`).classList.add("active");

        // find the correct slide to go to and go to it
        // the slide will have the same target as the tinsTarget
        let targetSlide = document.querySelector(`.productVisualSwiper.active`).querySelector(`.productVisualSwiperSlide.${tinsTarget}`) || false;

        // if there is a target slide, go to it
        if (targetSlide) {
            let index = parseInt(targetSlide.dataset.swiperSlideIndex);
            let swiper = document.querySelector(`.productVisualSwiper.active`).swiper;
            swiper.slideToLoop(index);
        }

        updateProduct();
    });
})

// update active variant
function updateProduct() {
    let sellingPlanExists = document.querySelector(".productSelling") || false;
    let payInstallmentsExists = document.querySelector(".productPayments") || false


    if (product.variants.length === 1) {
        // default fallback
        activeVariant = product.variants[0];
    } else {
        // collect options from inputs
        let options = [];
        document.querySelectorAll(`.productOptionItem`).forEach(group => {
            options.push(group.querySelector(`input:checked`).value);
        });

        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "not available";
        return;
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        document.querySelector("#productATC").classList.add("primary");
        document.querySelector("#productATC").disabled = false;
        document.querySelector("#productATC").textContent = "add to cart";
    } else {
        document.querySelector("#productATC").classList.remove("primary");
        document.querySelector("#productATC").disabled = true;
        document.querySelector("#productATC").textContent = "sold out";
    }

    // update payments form data
    if (payInstallmentsExists) {
        document.querySelector('.productPaymentsInput').value = activeVariant.id;
        document.querySelector('shopify-payment-terms').dataset.variantId = activeVariant.id;
        document.querySelector('shopify-payment-terms').setAttribute('variant-id', activeVariant.id);
    }


    // update variant images
    document.querySelectorAll('.productOptionItemValuesLabelBodyWrapInnerWrap.once').forEach((element) => {
        element.classList.add("active");

    });
    document.querySelectorAll('.productOptionItemValuesLabelBodyWrapInnerWrap.sub').forEach((element) => {
        element.classList.remove("active");
    });
    if (document.querySelector('.productSellingLabelInput.sub')?.checked) {
        document.querySelectorAll('.productOptionItemValuesLabelBodyWrapInnerWrap.once').forEach((element) => {
            element.classList.remove("active");
        });
        document.querySelectorAll('.productOptionItemValuesLabelBodyWrapInnerWrap.sub').forEach((element) => {
            element.classList.add("active");
        });
    }


    // update selling plan
    updateSellingPlan(sellingPlanExists, activeVariant)
}

/**************
 Product Selling Plan
 ***************/

function updateSellingPlan(sellingPlanExists = true, activeVariant) {
    // Selling Plan element doesn't exist
    if (!sellingPlanExists) {
        return;
    }

    let activeVariantPlan = activeVariant.selling_plan_allocations[0];

    // reset selcet
    let optionsHTML = "";
    // loop over every selling plan allocation for this active variant

    activeVariant.selling_plan_allocations.forEach(sellingPlanAllocation => {
        // find the selling plan name since it's not in the object
        let sellingPlan = getSellingPlanById(sellingPlanAllocation.selling_plan_id);

        // create an option for the select
        // manual check for the starter kit selling plan
        if (sellingPlanAllocation.selling_plan_group_id !== "91e7beddcc2b25a88da97e3b201deec8db7b43bb") {
            optionsHTML += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
        }
    });
    document.querySelector(".productSellingLabelBodyBottomWrapContentSelect").innerHTML = optionsHTML;


    // update text
    let save = (1 - (activeVariantPlan.price / activeVariant.price)) * 100;

    // save parent elements
    const once = document.querySelector(".productSellingLabelBody.once");
    const sub = document.querySelector(".productSellingLabelBody.sub");

    // update compare at price for one time and sub
    if (activeVariant.compare_at_price > activeVariant.price) {
        once.querySelector(".productSellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
    } else {
        once.querySelector(".productSellingLabelBodyPriceCompare").textContent = "";
    }

    sub.querySelector(".productSellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
    if (activeVariantPlan.compare_at_price > activeVariant.compare_at_price) {
        sub.querySelector(".productSellingLabelBodyPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity, true);
    }

    // update actual price
    once.querySelector(".productSellingLabelBodyPriceReal").textContent = price(activeVariant.price * quantity, true);
    sub.querySelector(".productSellingLabelBodyPriceReal").textContent = price(activeVariantPlan.price * quantity, true);

    once.querySelector(".productSellingLabelBodyPriceReal").classList.remove("sale");

    if (activeVariant.compare_at_price > activeVariant.price) {
        once.querySelector(".productSellingLabelBodyPriceReal").classList.add("sale");
    }


    // // update one time text
    once.querySelector(".productSellingLabelBodyBottomWrapContentTxt").innerHTML = `<strong>DOES NOT INCLUDE</strong> FREE SHIPPING, EXTRA 25% OFF, THE 21- DAY SLEEP RESET OR THE 30 DAY ACCESS TO THE <span>Open</span> APP`;


    // update one time bullets
    if (document.querySelector('.productOptionItemValuesLabelInput:checked').value === "4" && document.querySelector('.productSellingLabelInput:checked').value === "once") {
        once.querySelector(".productSellingLabelBodyBottomWrapContentBullets.once")?.classList.add("active");
    }

    document.querySelectorAll('.productSellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
        element.classList.remove("active");
    });
    if (document.querySelector('.productSellingLabelInput:checked').value === "sub") {
        document.querySelectorAll('.productSellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
            element.classList.add("active");
        });
    }

    // update 4 tins icons
    if (document.querySelector('.productOptionItemValuesLabelInput:checked').value === "4") {
        document.querySelectorAll('.productSellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
            element.classList.add("active");
        });

        document.querySelectorAll('.productSellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
            element.classList.remove("active");
        });
    }

    // update 2 tins icons
    if (document.querySelector('.productOptionItemValuesLabelInput:checked').value === "2") {
        document.querySelectorAll('.productSellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
            element.classList.add("active");
        });

        document.querySelectorAll('.productSellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
            element.classList.remove("active");
        });
    }


}


/****************
 * Product Quantity
 */

let quantity = 1;
updateProduct();


/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // check for selling plan
    if (document.querySelector('.productSellingLabelInput.sub')?.checked) {
        // find the correct selling_plan_allocation
        let activeVariantPlan = activeVariant.selling_plan_allocations[0];
        // find the correct selling_plan_allocation
        for (let plan of activeVariant.selling_plan_allocations) {
            if (plan.selling_plan_id === parseInt(document.querySelector('.productSellingLabelBodyBottomWrapContentSelect').value)) {
                activeVariantPlan = plan;
            }
        }
        formData.items[0].selling_plan = activeVariantPlan.selling_plan_id
    } else {

        // map back to original variants for one-time since they don't get the kit
        formData.items[0].id = activeVariant.id === 43809668071561 ? 40815844589705 : 40815844622473


    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


/**
 * Given a selling plan id, find the master selling plan object
 * @param {number} sellingPlanId
 * @returns {Object}
 */
function getSellingPlanById(sellingPlanId) {
    let sellingPlan = null;
    product.selling_plan_groups.forEach(group => {
        group.selling_plans.forEach(plan => {
            if (plan.id === sellingPlanId) {
                sellingPlan = plan;
            }
        });
    });
    return sellingPlan;
}


// font fix override for shopify payments (make b element normal weight)
document.addEventListener("DOMContentLoaded", async function () {
    customElements.whenDefined("shopify-payment-terms").then(() => {
        customElements.whenDefined("shop-pay-installments-banner").then(() => {
            document.querySelector("shopify-payment-terms").shadowRoot.querySelector("shop-pay-installments-banner").shadowRoot.querySelector("b").style = "font-weight: 400;";
        });
    });
});
